import { FC, useRef } from 'react'
import styles from './MakeYourSideYourOwn.module.scss'
import { MakeYourSideYourOwnProps } from './types'
import { Img } from 'components/basic/Img'
import { TempDialAnimateUp } from 'components/Phantom/TempDial'
import { observer } from 'mobx-react'
import { useRootStore } from 'components/_hooks/useRootStore'
import { useRefreshScrollTrigger } from 'components/_hooks/useRefreshScrollTrigger'

export const MakeYourSideYourOwnConnected = observer(() => {
	const { settingsStore } = useRootStore()
	return <MakeYourSideYourOwn metric={settingsStore.metricRegion} />
})

export const MakeYourSideYourOwn: FC<MakeYourSideYourOwnProps> = (props) => {
	const { metric = false } = props

	const containerRef = useRef(null)
	useRefreshScrollTrigger(containerRef)

	return (
		<section
			className={styles.container}
			ref={containerRef}
		>
			<header className={styles.header}>
				{/* <p className={styles.eyebrow}>Dual Zone Temperature</p> */}
				<h2>Make your side your own</h2>
			</header>
			<p className={styles.bottom_text}>You and your partner can both sleep at different temperatures in the same bed.</p>

			<div className={styles.bed_image_container}>
				<Img
					sources={[
						{
							src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/make_side_own_desktop_clean.jpg',
							mediaQuery: '(min-width: 1024px)',
						},
					]}
					src={'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/make_side_own_mobile_clean.jpg'}
					alt={'A top-down view of the Pod with red and blue regions indicating cooling and heating'}
					className={styles.bed_image}
					objectFit={'cover'}
					dprHeight={1000}
				/>
				<TempDialAnimateUp
					endTemp={65}
					metric={metric}
					text={'Their side'}
					className={styles.cool}
				/>
				<TempDialAnimateUp
					endTemp={78}
					metric={metric}
					text={'Your side'}
					className={styles.warm}
				/>
			</div>
		</section>
	)
}
